import $ from 'jquery'

export default function initEitherOr(): void {
	$('.js-either-or')
		.each(function (this: HTMLElement) {
			const $this = $(this)

			$this.data('orig', $this.val() ?? '')
		})
		.on('change keyup', function (this: HTMLElement) {
			const $this = $(this)
			const $cont = $this.closest('.js-either-or-container')
			const $other = $('.js-either-or', $cont).not($this)

			$other.prop('disabled', $this.val() !== $this.data('orig'))
		})
}